export { RippleDirective } from './ripple-effect.directive';
export { RippleModule } from './ripple.module';



// WEBPACK FOOTER //
// ./src/app/angular-bootstrap-md/ripple/index.ts